import { useQuery } from '@tanstack/react-query';

import { ITopicTestsRes } from '../models';
import { getTopicTests } from '../queries';
import { topicTestsConst } from '..';

export const useTopicTests = ({
  search,
  page,
  languageId,
  name
}: {
  search?: string
  page?: string;
  name?: string;
  languageId?: number;
}) =>
  useQuery<ITopicTestsRes>({
    queryKey: [topicTestsConst.queryKeys.USE_TOPIC_TEST, page, languageId, name, search],
    queryFn: getTopicTests({ page, languageId, name, search })
  });
